/**
 * Line-item performance feature flags.
 *
 * Defaults:
 *   KN_FEATURE_LINE_VIRTUALIZE      = true  (auto-size virtual list)
 *   KN_FEATURE_LINE_IO_LAZY_LOAD    = false (DutyItem / DeferredContent IO is off)
 *
 * Override without a rebuild (read on each call; refresh or re-render to apply):
 *   window.KN_FEATURE_LINE_VIRTUALIZE = false
 *   window.KN_FEATURE_LINE_IO_LAZY_LOAD = true
 *   localStorage.setItem('KN_FEATURE_LINE_VIRTUALIZE', 'false')
 *   localStorage.setItem('KN_FEATURE_LINE_IO_LAZY_LOAD', 'true')
 *   ?KN_FEATURE_LINE_VIRTUALIZE=false
 *   ?KN_FEATURE_LINE_IO_LAZY_LOAD=true
 */

export const LINE_ITEM_FLAG = {
  VIRTUALIZE: 'KN_FEATURE_LINE_VIRTUALIZE',
  IO_LAZY_LOAD: 'KN_FEATURE_LINE_IO_LAZY_LOAD',
}

const DEFAULTS = {
  [LINE_ITEM_FLAG.VIRTUALIZE]: true,
  [LINE_ITEM_FLAG.IO_LAZY_LOAD]: false,
}

function parseBool(value, fallback) {
  if (value === true || value === false) return value
  if (value == null || value === '') return fallback
  const normalized = String(value).trim().toLowerCase()
  if (normalized === 'true' || normalized === '1' || normalized === 'on' || normalized === 'yes') {
    return true
  }
  if (normalized === 'false' || normalized === '0' || normalized === 'off' || normalized === 'no') {
    return false
  }
  return fallback
}

function readQueryParam(name) {
  try {
    if (typeof window === 'undefined' || !window.location) return null
    return new URLSearchParams(window.location.search).get(name)
  } catch (e) {
    return null
  }
}

function readLocalStorage(name) {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return null
    return window.localStorage.getItem(name)
  } catch (e) {
    return null
  }
}

function readEnv(name) {
  try {
    const env = (typeof window !== 'undefined' && window._env_) || {}
    return env[name]
  } catch (e) {
    return null
  }
}

export function readLineItemFlag(name) {
  const fallback = DEFAULTS[name]
  if (typeof window !== 'undefined' && window[name] != null && window[name] !== '') {
    return parseBool(window[name], fallback)
  }
  const query = readQueryParam(name)
  if (query != null) return parseBool(query, fallback)
  const stored = readLocalStorage(name)
  if (stored != null) return parseBool(stored, fallback)
  const env = readEnv(name)
  if (env != null && env !== '') return parseBool(env, fallback)
  return fallback
}

export function isLineItemVirtualizationEnabled() {
  return readLineItemFlag(LINE_ITEM_FLAG.VIRTUALIZE)
}

export function isLineItemIoLazyLoadEnabled() {
  return readLineItemFlag(LINE_ITEM_FLAG.IO_LAZY_LOAD)
}
